'use strict';

var base = require('base/login/login');
var formValidation = require('base/components/formValidation');
var addressHelper = require('../addressBook/addressBook');
var Recaptcha = require('../util/recaptcha');

/**
 * Submit registration of account
 * @param {Object} form - form object
 * @param {function} successCallback - function to call when operation was successful
 */
function submitRegistration(form, successCallback) {
    var url = form.attr('action');

    Recaptcha.generateToken('account_register').then(function (token) {
        var requestData = form.serialize();
        requestData += '&g-recaptcha-response=' + token;
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: requestData,
            success: function (data) {
                if (data.success === false) {
                    form.spinner().stop();
                    $('.js-error-message').html(data.errorMessage);
                    $('#registerUnsuccessfulModal').modal('show');
                } else if (!data.success) {
                    form.spinner().stop();
                    formValidation(form, data);
                } else {
                    form.spinner().stop();
                    successCallback(data);
                }
            },
            error: function (err) {
                if (typeof err.responseJSON !== 'undefined') {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        base.createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                    }
                }

                form.spinner().stop();
            }
        });
    });
}

/**
 * Reset layout of modal from confirmation message to form in case of sequential password reset
 */
function handlePwResetModal() {
    $('#password-reset').click(function () {
        $('.request-password-title').removeClass('d-none');
        $('.request-password-body').removeClass('d-none');

        if ($('.confirm-req-pw-body')) {
            $('.confirm-req-pw-body').remove();
        }
        if ($('.confirm-req-pw-title')) {
            $('.confirm-req-pw-title').remove();
        }

        $('.request-password-noaccount').removeClass('d-none');
        $('.request-password-noaccount').addClass('d-flex');

        $('.forgot-password-page .reset-password-form, .modal-body').removeClass('mb-5');

        var submitBtnTxt = $('#submitEmailButton').data('txtsubmit');
        $('#submitEmailButton').text(submitBtnTxt)
        .removeAttr('data-dismiss');
    });
}

module.exports = {
    base: base,
    changePostalCodePattern: () => {
        addressHelper.assignPostalCodePattern();
        $('#country').on('change', addressHelper.assignPostalCodePattern);
    },
    login: function () {
        $('form.login').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $('form.login').trigger('login:submit', e);
            Recaptcha.generateToken('account_login').then(function (token) {
                var dataAction = $('.page').data('action') || 'Home-Show';
                if (dataAction === 'Search-Show' || dataAction === 'Page-Show') {
                    dataAction += '?' + $('.page').data('querystring');
                }

                var requestData = form.serialize();
                requestData += '&endpoint=' + dataAction + '&g-recaptcha-response=' + token;
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: requestData,
                    success: function (data) {
                        form.spinner().stop();
                        if (!data.success) {
                            formValidation(form, data);
                            $('form.login').trigger('login:error', data);
                        } else {
                            $('form.login').trigger('login:success', data);
                            location.href = data.redirectUrl;
                        }
                    },
                    error: function (data) {
                        if (data.responseJSON.redirectUrl) {
                            window.location.href = data.responseJSON.redirectUrl;
                        } else {
                            $('form.login').trigger('login:error', data);
                            form.spinner().stop();
                        }
                    }
                });
            });
            return false;
        });
    },
    resetPassword: function () {
        handlePwResetModal();

        $('.reset-password-form').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $('.reset-password-form').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        $('.request-password-title')
                            .addClass('d-none')
                            .before('<h2 class="modal-title mb-4 text-center confirm-req-pw-title">' + data.receivedMsgHeading + '</h2>');
                        $('.request-password-body')
                            .addClass('d-none')
                            .before('<div class="confirm-req-pw-body"><p class="mb-4 text-tertiary text-center">' + data.receivedMsgBody + '</p></div>');
                        $('.request-password-noaccount')
                            .addClass('d-none')
                            .removeClass('d-flex');

                        $('.forgot-password-page .reset-password-form, .modal-body').addClass('mb-5');
                        if (!data.mobile) {
                            $('#submitEmailButton').text(data.buttonText)
                                .attr('data-dismiss', 'modal');
                        } else {
                            $('.send-email-btn').empty()
                                .html('<a href="'
                                    + data.returnUrl
                                    + '" class="btn btn-primary btn-block justify-content-center">'
                                    + data.buttonText + '</a>'
                                );
                        }
                    }
                },
                error: function () {
                    form.spinner().stop();
                }
            });
            return false;
        });
    },
    registerAccount: function () {
        $('form.create-account-form').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            form.spinner().start();
            $('form.create-account-form').trigger('login:register', e);
            submitRegistration(form, data => {
                location.href = data.redirectUrl;
            });
        });
    },
    termsAndConditionsChanged: function () {
        $('.js-terms-conditions-checkbox').change(function () {
            $('button[type=submit]', $('form.create-account-form')).prop('disabled', !this.checked);
        });
    }
};
